module.exports = __webpack_public_path__ + "img/fcc32ab.jpg";